/* eslint-disable prettier/prettier */
/* eslint-disable no-empty-function */
/* eslint-disable prettier/prettier */
import { getBusinessObject, is } from "bpmn-js/lib/util/ModelUtil";
import { escapeHTML } from "bpmn-js-properties-panel/lib/Utils";
import React from "react";
import { createRoot } from "react-dom/client";

import ModelerSectionGerarLinkPublico from "./modeler-section-gerar-link-publico";
import { language } from "../../../../../language";
import Provider from "../../../../../Provider";
import {
  getExtensionElement,
  modifyExtensionElement,
} from "../../../../../util/camundaPropertiesPanelUtils";

function RenderGenerateLinkComponent(
  elementdom,
  saveProcessLinkOnModeler,
  element,
) {
  const root = createRoot(elementdom);
  root.render(
    <Provider>
      <ModelerSectionGerarLinkPublico
        element={element}
        saveProcessLinkOnModeler={saveProcessLinkOnModeler}
      />
    </Provider>,
  );
}

function ensureFormKeyAndDataSupported(element) {
  return is(element, "bpmn:StartEvent");
}

export default function (
  group,
  element,
  bpmnFactory,
  options,
  translate,
  modeling,
) {
  const businessObject = getBusinessObject(element);

  // salva url no camundaProperties
  const saveProcessLinkOnModeler = function (element, linkObject) {
    const bo = getBusinessObject(element);
    const linkValue = linkObject && linkObject.link;
    modifyExtensionElement(
      "urlPublicLink",
      linkValue,
      element,
      bo,
      bpmnFactory,
      modeling,
    );
  };

  // busca url do camundaProperties
  const getProcessLinkValue = function (element) {
    const bo = getBusinessObject(element);
    const linkValue = getExtensionElement("urlPublicLink", bo);
    return {
      urlPublicLink: linkValue,
    };
  };

  if (!ensureFormKeyAndDataSupported(element)) {
    return;
  }

  // botão que gera o link

  const idUrlPulicLinkButton = "url-public-link-button";
  const labelUrlPublicLinkButton = language.generatePublicLink;

  group.entries.push({
    id: idUrlPulicLinkButton,
    html:
      '<button id="cam-extensionElements-' +
      escapeHTML(idUrlPulicLinkButton) +
      '"' +
      'data-action="generatePublicLink" ' +
      'name="selectedExtensionElement" ' +
      'class="btn info"' +
      'style="margin-left: auto;margin-right: auto;width: 100%; margin-top: 20px"' +
      '" >' +
      labelUrlPublicLinkButton +
      "</button>",
    generatePublicLink(element, node) {
      const modelerGenerateLinkPublic = document.createElement(
        "modelerGenerateLinkPublic",
      );

      RenderGenerateLinkComponent(
        modelerGenerateLinkPublic,
        saveProcessLinkOnModeler,
        element,
      );
    },
  });

  // campo com a url

  const idUrlPulicLink = "url-public-link";
  const labelUrlPublicLink = language.publicUrlLink;
  const modelPropertyUrlPublicLink = "urlPublicLink";

  const urlPublicLinkValue = getExtensionElement(
    "urlPublicLink",
    businessObject,
  );

  if (urlPublicLinkValue) {
    group.entries.push({
      id: idUrlPulicLink,
      html:
        "<label >" +
        labelUrlPublicLink +
        "</label> " +
        '<div class="bpp-field-wrapper" ' +
        'data-disable="isDisabled" ' +
        ">" +
        '<input id="camunda-' +
        escapeHTML(idUrlPulicLink) +
        '" type="text" name="' +
        escapeHTML(modelPropertyUrlPublicLink) +
        '" ' +
        'data-disable="isDisabled" ' +
        'style="padding-right: 40px;" ' +
        " />" +
        '<svg xmlns="http://www.w3.org/2000/svg" height="24" width="24" viewBox="0 0 24 24" ' +
        'data-action="copyPublicLink" ' +
        'style="position: absolute; right: 10px; top: 50%; transform: translateY(-50%); cursor: pointer; width: 22px; height: 22px; fill: #555;" ' +
        ">" +
        '<path d="M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z"/>' +
        "</svg> " +
        '<span id="tooltip-smart-url-public-link" ' +
        'style="position: absolute; top: -30px; right: 0; background-color: #333; color: #fff; padding: 4px 8px; font-size: 12px; border-radius: 4px; opacity: 0; pointer-events: none; transition: opacity 0.3s;" ' +
        ">" +
        language.linkCopied +
        "</span> " +
        "</div>",
      get: (el) => getProcessLinkValue(el),
      set: (el, values) => {},
      isDisabled() {
        return true;
      },
      copyPublicLink() {
        const input = document.getElementById("camunda-" + idUrlPulicLink);
        const tooltip = document.getElementById(
          "tooltip-smart-url-public-link",
        );

        const showTooltip = () => {
          tooltip.style.opacity = "1";
          setTimeout(() => {
            tooltip.style.opacity = "0";
          }, 1500);
        };

        input.select();
        input.setSelectionRange(0, 99999);

        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard
            .writeText(input.value)
            .then(() => showTooltip())
            .catch((err) => {
              console.warn(`Erro ao copiar link: ${err}, tentando outro caminho, aguarde...`);
              fallbackCopy();
            });
        } else {
          fallbackCopy();
        }

        function fallbackCopy() {
          try {
            const successful = document.execCommand("copy");
            if (successful) {
              showTooltip();
            } else {
              console.error("Unable to copy");
            }
          } catch (err) {
            console.error("Fallback copy error", err);
          }
        }
      },
    });
  }
}
